import { ReactComponent as SmilyFaceImg } from "assets/icons/empty.svg";

const EmptyList = () => (
    <div className="empty-list text-center">
        <SmilyFaceImg />
        <h6 className="mt-4">در حال حاضر آیتمی موجود نیست.</h6>
    </div>
);

export default EmptyList;
